import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template9.css";
import "./CheckoutTemplate9.css";

/*
   Checkout Template 9 — a seamless continuation of sales Template 9
   ("Split Sticky Magazine", premium dark). Reuses Template9.css directly
   (the .clp9-root dark design system: Fraunces serif titles, amber --p accent,
   #14161e panels): the real .m9-mobar top bar, the left rail's radial-gradient
   treatment with its .m9-eyebrow/.m9-dot + .m9-title, the .m9-btn.m9-btn-p
   primary and the .m9-foot footer. Only the form + order-summary cards are
   checkout-specific (CheckoutTemplate9.css), styled as dark template panels.
*/
export default function ThankYouTemplate9({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp9-root cok9-root">
      {/* NAV — the sales top bar, forced visible for checkout */}
      <div className="m9-mobar scr cok9-bar">
        <span className="m9-mobar-logo">
          {c.logo ? <img src={c.logo} alt="" /> : <span className="cok9-brandtext">{c.brand}</span>}
        </span>
        <span className="cok9-secure">✓ Order confirmed</span>
      </div>

      {/* HERO — reuses the rail's dark band + radial glow + accent line + Fraunces title */}
      <section className="cok9-hero">
        <span className="m9-rail-line" aria-hidden="true" />
        <div className="cok9-hero-in">
          <span className="m9-eyebrow cok9-eyebrow"><span className="m9-dot" /> Checkout</span>
          <h1 className="m9-title cok9-h1">
            You're <span className="cok9-accent">enrolled</span>
          </h1>
          {c.sub ? <p className="m9-rail-sub cok9-sub">{c.sub}</p> : null}
        </div>
      </section>

      {/* FORM + ORDER SUMMARY — dark cards matching the template's panels */}
      <div className="cok9-wrap">
        <ThankYouBody data={data} p="cok9" c={c} />
      </div>

      {/* FOOTER — the sales footer bar, one centered line */}
      <footer className="m9-foot cok9-foot">
        <div className="m9-foot-in cok9-foot-in">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
      </footer>
    </div>
  );
}
